// extracted by css-extract-rspack-plugin
export default {"handle_btn":"handle_btn___X-9FW","table_icon":"table_icon___lpQ2A"};